/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { formAddressInitialState } from './constant/formAddressConstants';
import { IFormAddressReducer } from './formAddressReducer';
import {
    IFormAddressConfiguration,
    TFormAddressSearchFoundItems,
    TFormAddressSearchIsLoading,
} from './types/formAddressTypes';

export const makeSelectFormAddress = (state: IRootReducer): IFormAddressReducer =>
    state.formAddress || formAddressInitialState;

/*
* -------------------------------------------
*       Form Initializing
* -------------------------------------------
*/

export const makeSelectFormAddressIsInit = (): OutputSelector<IRootReducer, boolean,
    (state: IFormAddressReducer) => boolean> =>
    createSelector(makeSelectFormAddress, state => state.isFormInit);

/*
* -------------------------------------------
*       Get Address
* -------------------------------------------
*/

export const makeSelectFormAddressConfiguration = (): OutputSelector<IRootReducer, IFormAddressConfiguration,
    (state: IFormAddressReducer) => IFormAddressConfiguration> =>
    createSelector(makeSelectFormAddress, state => state.addressConfiguration);

export const makeSelectFormAddressString = (): OutputSelector<IRootReducer, string,
    (state: IFormAddressReducer) => string> =>
    createSelector(makeSelectFormAddress, state => state.addressConfiguration.addressString);

/*
* -------------------------------------------
*       Search for Address Matches
* -------------------------------------------
*/

export const makeSelectFormAddressSearchFoundItems = (): OutputSelector<IRootReducer, TFormAddressSearchFoundItems,
    (state: IFormAddressReducer) => TFormAddressSearchFoundItems> =>
    createSelector(makeSelectFormAddress, state => state.searchFoundItems);

export const makeSelectFormAddressSearchIsLoading = (): OutputSelector<IRootReducer, TFormAddressSearchIsLoading,
    (state: IFormAddressReducer) => TFormAddressSearchIsLoading> =>
    createSelector(makeSelectFormAddress, state => state.searchIsLoading);

